module.exports = __webpack_public_path__ + "img/about-position-box2.jpg?43200563d34f31155a5de3d98a17a667";